
import { defineComponent } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  mounted () {},
  data () {
    return {}
  },
  computed: {
    Name () {
      return this.Translate('Security')
    },
    Tabs () {
      return [
        { Name: this.Translate('Branches'), Link: 'View', Access: this.Access('Branches_Read') }
      ] as Array<CookiesTabs>
    }
  },
  methods: {},
  watch: {}
})
